import { isEmpty } from 'lodash';
import type { CMSProps, GQLProps, GQLData } from 'Cms/products-grid/resolver';
import { getProductProps } from 'Components/widgets/product/Product.mapper';
import type { ProductProps } from 'Components/widgets/product/Product.utils';
import 'Components/widgets/product/Product.utils';
import { castAs } from 'Src/types/cast-helpers';
type Props = CMSProps & GQLProps & GQLData;
export const productsMapper = (props: Props): Array<ProductProps> => {
  const { products = [], productIds = [], config, offer = {} } = props;
  return productIds
    .reduce((prev, next) => {
      if (products?.length) {
        const product = products.find(({ id }) => next === id);

        if (product) {
          prev.push(product);
        }
      }

      return prev;
    }, [])
    .map((product) => {
      return getProductProps({
        config,
        product,
        contextualizeUrl: !!(props.departureDateStart && props.departureDateEnd),
        offer: !isEmpty(offer) ? castAs<Offer>(offer) : undefined,
      });
    });
};
export const asyncPropsMapper = (
  initialProps: {
    products: Array<ProductProps>;
  },
  moreProducts: Array<ProductProps>,
): {
  products: Array<ProductProps>;
} => {
  const { products = [] } = initialProps;
  return {
    products: [...products, ...moreProducts],
  };
};
